/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldPermissionData } from './FieldPermissionData';
import {
    FieldPermissionDataFromJSON,
    FieldPermissionDataFromJSONTyped,
    FieldPermissionDataToJSON,
    FieldPermissionDataToJSONTyped,
} from './FieldPermissionData';

/**
 * 
 * @export
 * @interface FieldPermissionResponse
 */
export interface FieldPermissionResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof FieldPermissionResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof FieldPermissionResponse
     */
    error?: string;
    /**
     * 
     * @type {FieldPermissionData}
     * @memberof FieldPermissionResponse
     */
    data?: FieldPermissionData;
}

/**
 * Check if a given object implements the FieldPermissionResponse interface.
 */
export function instanceOfFieldPermissionResponse(value: object): value is FieldPermissionResponse {
    return true;
}

export function FieldPermissionResponseFromJSON(json: any): FieldPermissionResponse {
    return FieldPermissionResponseFromJSONTyped(json, false);
}

export function FieldPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'data': json['data'] == null ? undefined : FieldPermissionDataFromJSON(json['data']),
    };
}

export function FieldPermissionResponseToJSON(json: any): FieldPermissionResponse {
    return FieldPermissionResponseToJSONTyped(json, false);
}

export function FieldPermissionResponseToJSONTyped(value?: FieldPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'data': FieldPermissionDataToJSON(value['data']),
    };
}

